import apiClient from '@/api/apiClient'

export const getCannedResponses = accountId =>
  apiClient.get(`api/v1/accounts/${accountId}/canned_responses`)

export const createCannedResponse = (accountId, payload) =>
  apiClient.post(`api/v1/accounts/${accountId}/canned_responses`, payload)

export const updateCannedResponse = (accountId, id, payload) =>
  apiClient.patch(
    `api/v1/accounts/${accountId}/canned_responses/${id}`,
    payload
  )

export const deleteCannedResponse = (accountId, id) =>
  apiClient.delete(`api/v1/accounts/${accountId}/canned_responses/${id}`)
